<template>
    <div style="float: left;width: 100%">
        <el-carousel :height=computeHeight indicator-position="outside">
            <el-carousel-item v-for="item in sliders">
                <img :src="item.img" class="slider_img">
            </el-carousel-item>
        </el-carousel>
        <div class="solve">
            <div style="margin: auto;" class="font_size_24">
            </div>
        </div>
        <!-- 吴晓波频道 -->
        <div id="吴晓波频道" style="display:flex; margin-top: 20px">
            <div style="width: 100%; margin: auto" class="font_size_24">
                吴晓波频道
            </div>
        </div>
        <div class="product_mobile">
            <div class="product_mobile_content">
                <div class="product_mobile_title font_size_30">从一个人到一群人</div>
                <div class="product_font_style product_mobile_content_one">挖掘：新闻背后的财经知识</div>
                <div class="product_font_style product_mobile_content_two">发现：数据之中的商业价值</div>
                <div class="product_font_style product_mobile_content_two">理解：新中产的需求与焦虑，共同成长</div>
                <div class="product_font_style product_mobile_content_two">助力：企业家提升自我，不惧前行</div>
            </div>
            <div class="product_mobile_img_div">
                <img :src="products[0].img[0]" class="product_mobile_img"/>
            </div>
        </div>
        <!-- 关于我们-->
        <div id="关于我们" class="about_me">
            <div style="width: 90%;" class="font_size_24">
                关于我们
            </div>
        </div>
        <div style="width: 100%;background-color: #F2F6FC;margin-top: 10px">
            <div style="display: flex; flex-direction: column;align-items: center;width: 100%;">
                <p class="about_me_p">从2016年推出第一个知识服务产品《每天听见吴晓波》开始，至今已拥有150+门线上课程。</p>
                <p class="about_me_p">为了更好的服务新中产的知识需求，我们于2019年推出吴晓波频道App——一个会员制知识服务平台，旨在解决新中产在个人投资、创业、职场及见识进阶等方面的实际问题。</p>
                <p class="about_me_p">在传统线上课程的基础上，我们为会员提供了更高效的解决问题方式：7天训练营、线上老师一对一答疑，不同城市的线下课程等，希望可以帮助新中产升级认知体系，提升解决问题的效率，在人生的路上，跑得更快一点。</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                sliders: [],
                products: [
                    {
                        img: [require('../../static/other/pic_1@2x.jpg')]
                    },
                    {
                        img: [require('../../static/other/pic_2@2x.jpg')]
                    }
                ],
                carousel_height: '550px',
            }
        },
        methods: {},
        mounted() {
            this.sliders = [
                {
                    img: require("../../static/slider/1.jpg")
                }
            ]
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }

        },
    }
</script>

<style scoped>
    .border_parent {
        display: flex;
        width: 90%;
        margin: auto;
        height: auto
    }

    .slider_img {
        height: 550px;
        width: 100%;
    }

    .solve {
        display: flex;
        margin-top: 30px;
        margin-bottom: 10px
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 20%;
        height: auto;
        margin: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
        /*background: aquamarine;*/
    }

    .border_one {
        margin-left: 0;
    }

    .border_img_parent {
        margin-top: 20px
    }

    .product_mobile_content {
        width: 50%;
    }

    .product_mobile_img {
        float: left;
        height: 510px;
        width: 530px;
        margin-left: 50px;
    }

    .product_mobile_title {
        font-weight: bold;
    }

    .product_pc_one {
        width: 50%;
        float: left;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .product_font_style {
        font-size: 1.125em;
    }

    .product_pc_img {
        height: 510px;
        width: 600px
    }

    .product_pc_img_div {
        width: 50%;
        float: left;
        display: flex;
        align-items: center;
    }

    .product_pc {
        display: flex;
        width: 90%;
        height: 540px;
        margin: 20px auto;
        background: #F2F6FC;
        align-items: center;
    }

    .cooperation_parent {
        display: flex;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .about_me_p {
        font-size: 1.25em;
        font-weight: normal;
        width: 60%;
        text-align: left;
        margin: 10px;
    }

    .border_title {
        font-family: "PingFang SC";
        margin-top: 10px;
        font-size: 1.125em;
        font-weight: bold;
    }

    .border_content_one {
        margin-top: 20px;
        font-size: 1.125em;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 25px;
    }

    .img_border {
        margin-top: 15px;
        width: 80px;
        height: 80px
    }

    .cooperation {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        width: 100%;
    }

    .about_me {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        width: 100%;
    }

    .product_mobile {
        display: flex;
        width: 90%;
        align-items: center;
        margin: 20px auto;
        height: 540px;
        background: #F2F6FC;
    }

    .product_mobile_img_div {
        width: 50%;
        height: auto;
    }

    .product_mobile_content_one {
        margin-top: 20px;
    }

    .product_mobile_content_two {
        margin-top: 10px;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 250px;
            width: 100%;
        }

        .solve {
            display: flex;
            margin-top: 5px;
            margin-bottom: 10px
        }

        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

        .border_img_parent {
            margin-top: 0
        }

        .product_mobile {
            display: flex;
            width: 90%;
            align-items: center;
            margin: 20px auto;
            height: auto;
            background: #F2F6FC;
            flex-direction: column;
            justify-content: center;
        }

        .product_mobile_content {
            width: 100%;
            margin-top: 15px;
        }

        .product_mobile_content_one {
            margin-top: 5px;
        }

        .product_mobile_content_two {
            margin-top: 5px;
        }

        .product_mobile_img_div {
            display: flex;
            width: 100%;
            height: auto;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 15px;
        }

        .product_mobile_img {
            float: left;
            height: 280px;
            width: 160px;
            /*margin-left: 5px;*/
            margin: auto;
        }

        .product_mobile_title {
            font-weight: bold;
        }

        .product_pc_one {
            width: 100%;
            margin-top: 15px;
        }

        .font_size_30 {
            font-size: 1.25em;
        }

        .product_font_style {
            font-size: 1em;
        }

        .product_pc_img {
            height: 280px;
            width: 320px;
        }

        .product_pc_img_div {
            width: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
        }

        .product_pc {
            display: flex;
            width: 90%;
            height: auto;
            margin: 20px auto;
            background: #F2F6FC;
            flex-direction: column;
        }

        .about_me_p {
            font-size: 1em;
            font-weight: normal;
            width: 90%;
            text-align: left;
            margin: 5px;
        }

        .border_title {
            font-family: "PingFang SC";
            margin-top: 5px;
            font-size: 1.125em;
            font-weight: bold;
        }

        .border_content_one {
            margin-top: 5px;
            font-size: 1.125em;
        }

        .border_content_two {
            margin-top: 5px;
            font-size: 1.125em;
            margin-bottom: 8px;
        }

        .img_border {
            margin-top: 8px;
            width: 80px;
            height: 80px
        }

        .about_me {
            display: flex;
            margin-top: 10px;
            justify-content: center;
            width: 100%;
        }
    }

    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    .font_size_24 {
        font-size: 1.5em;
    }
</style>
